module.exports = __webpack_public_path__ + "static/media/profile-image-placeholder.cbfb95a7.svg";